<template>
  <div id="app">
    <Header />
    <transition>
      <router-view/>
    </transition>
  </div>
</template>
<script>
import Header from './components/Header'
export default {
  name: 'App',
  components: {
    Header
  }
}
</script>

<style lang="less">
@import url('./less/index.less');
</style>
